import AddHealthcareCompany from "@features/clinics/pages/AddHealthcareCompany";
import { AppModeSelector } from "@shared/ui";
import { EntityList } from "@shared/ui";
import { NotYetPlannedPage } from "@shared/ui";
import { ProtectedRoute } from "@shared/ui";
import EventsWrapper from "@features/events/components/EventsWrapper";
import EventAttendeeDetail from "@features/events/pages/attendees/EventAttendeeDetail";
import EventAttendeeTags from "@features/events/pages/attendees/EventAttendeesTags";
import EventAttendees from "@features/events/pages/attendees/EventAttendees";
import BrandProfile from "@features/events/pages/brand-profile/BrandProfile";
import BrandDetails from "@features/events/pages/brands/BrandDetails";
import EventBrands from "@features/events/pages/brands/EventBrands";
import EventsDashboardPage from "@features/events/pages/dashboard/EventsDashboardPage";
import EventPayments from "@features/events/pages/finance/transactions/EventPayments";
import EventPayouts from "@features/events/pages/finance/payouts/EventPayouts";
import EventInstructors from "@features/events/pages/instructors/EventInstructors";
import InstructorDetails from "@features/events/pages/instructors/InstructorDetails";
import EventDetails from "@features/events/pages/events/EventDetails";
import EventsList from "@features/events/pages/events/EventsList";
import EventVenues from "@features/events/pages/venues/EventVenues";
import VenueDetails from "@features/events/pages/venues/VenueDetails";
import useNavigateToEntity from "@shared/hooks/navigation/useNavigateToEntity";
import { EVENT_ROUTES, ROOTS } from "@app/config/constants";
import { findEventOrganizerByPath } from "@shared/lib";
import { EntityType, HealthcareCompanyType } from "@shared/types/commonTypes";
import { Route } from "react-router-dom";
import { useTranslation } from "react-i18next";

const EventOrganizerListRoute = () => {
  const { t } = useTranslation();
  const { navigateToEntity } = useNavigateToEntity({
    rootPath: ROOTS.EVENTS,
    lastVisitedKey: "__LAST_VISITED_E_ID",
    findEntityByPath: findEventOrganizerByPath,
  });
  return (
    <EntityList
      entityType={EntityType.EVENT}
      title={t("eventOrganizerList.title")}
      addNewLabel={t("eventOrganizerList.addNew")}
      queryKey={["healthcare-companies", HealthcareCompanyType.EVENT_ORGANIZER]}
      rootPath={ROOTS.EVENTS}
      lastVisitedKey="__LAST_VISITED_E_ID"
      navigateToEntity={navigateToEntity}
    />
  );
};

export default function EventRoutes() {
  return (
    <>
      <Route
        path={`${ROOTS.EVENTS}`}
        element={
          <ProtectedRoute>
            <EventOrganizerListRoute />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROOTS.EVENTS}/add`}
        element={
          <ProtectedRoute>
            <AddHealthcareCompany />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${ROOTS.EVENTS}/:eventOrganizerId`}
        element={
          <ProtectedRoute>
            <EventsWrapper />
          </ProtectedRoute>
        }
      >
        <Route index element={<EventsDashboardPage />} />
        <Route path={EVENT_ROUTES.EVENTS} element={<EventsList />} />
        <Route path={EVENT_ROUTES.EVENT_DETAILS} element={<EventDetails />} />
        <Route path={EVENT_ROUTES.ATTENDEES} element={<EventAttendees />} />
        <Route
          path={EVENT_ROUTES.ATTENDEE_DETAILS}
          element={<EventAttendeeDetail />}
        />
        <Route
          path={EVENT_ROUTES.ATTENDEE_TAGS}
          element={<EventAttendeeTags />}
        />
        <Route
          path={EVENT_ROUTES.ATTENDEE_TAG_DETAILS}
          element={<NotYetPlannedPage />}
        />
        <Route path={EVENT_ROUTES.INSTRUCTORS} element={<EventInstructors />} />
        <Route
          path={EVENT_ROUTES.INSTRUCTOR_DETAILS}
          element={<InstructorDetails />}
        />
        <Route path={EVENT_ROUTES.TRANSACTIONS} element={<EventPayments />} />
        <Route path={EVENT_ROUTES.PAYOUTS} element={<EventPayouts />} />
        <Route path={EVENT_ROUTES.BRANDS} element={<EventBrands />} />
        <Route path={EVENT_ROUTES.BRAND_DETAILS} element={<BrandDetails />} />
        <Route path={EVENT_ROUTES.VENUES} element={<EventVenues />} />
        <Route path={EVENT_ROUTES.VENUE_DETAILS} element={<VenueDetails />} />
        <Route path={EVENT_ROUTES.PROFILE} element={<BrandProfile />} />
        <Route path="*" element={<AppModeSelector />} />
      </Route>
    </>
  );
}
